import { BOOKING_NUMBERS, BOOKING_REQUESTS, BookingRequestsView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { usePeriodRange } from '@/app/hooks/usePeriodRange';

/** Online bookings (spec 50 §3) — the read-only staff list. */
export function OnlineBookingsPage() {
  const navigate = useNavigate();
  const [period, setPeriod] = usePeriodRange();
  return (
    <BookingRequestsView
      rows={BOOKING_REQUESTS}
      numbers={BOOKING_NUMBERS}
      period={period}
      onPeriodChange={setPeriod}
      onSettings={() => { void navigate('/settings/online-booking'); }}
      onTriage={() => { void navigate('/triage'); }}
      onAppointment={() => { void navigate('/calendar'); }}
    />
  );
}
